import Cookies from 'js-cookie';

const ONE_YEAR = 365;

export function getCookie(id) {
  return Cookies.getJSON(id);
}

export function setCookie(id, value, expires = ONE_YEAR) {
  Cookies.set(id, value, { expires });
}
